import booker from 'booker/resources'
import bot from 'maia/resources'

// eslint-disable-next-line 
export default {
   "en-us": Object.assign({},
      booker['en-us'],
      bot['en-us']
   )
};
